<script>
import { h } from 'vue';
import WootButton from 'dashboard/components/ui/WootButton.vue';
import Campaign from './Campaign.vue';
import AddCampaign from './AddCampaign.vue';
import CampaignContactsSelector from './components/CampaignContactsSelector.vue';
import CampaignGroupsManager from './components/CampaignGroupsManager.vue';
import CreateContactGroupModal from './components/CreateContactGroupModal.vue';
import AddContactsToGroupModal from './components/AddContactsToGroupModal.vue';
import ImportContactGroupCsvModal from './components/ImportContactGroupCsvModal.vue';

export default {
  components: {
    Campaign,
    AddCampaign,
    CampaignContactsSelector,
    CampaignGroupsManager,
    CreateContactGroupModal,
    AddContactsToGroupModal,
    ImportContactGroupCsvModal,
  },
  setup() {
    // const { isOngoingType } = useCampaign();
    // Comentado: ongoing removido - apenas one_off
    // return { isOngoingType };
    return {};
  },
  data() {
    return { 
      showAddPopup: false,
      selectedContacts: [],
      showCreateGroupModal: false,
      showAddToGroupModal: false,
      showImportCsvModal: false,
      groupsVersion: 0,
      activeTab: 0,
      groupsCount: 0,
    };
  },
  computed: {
    buttonText() {
      // Comentado: ongoing removido - apenas one_off
      // if (this.isOngoingType) {
      //   return this.$t('CAMPAIGN.HEADER_BTN_TXT.ONGOING');
      // }
      return this.$t('CAMPAIGN.HEADER_BTN_TXT.ONE_OFF');
    },
    hasSelectedContacts() {
      return this.selectedContacts.length > 0;
    },
    canCreateGroup() {
      return this.selectedContacts.length >= 2;
    },
    audienceCount() {
      return this.selectedContacts.length;
    },
    campaignsCount() {
      return this.$store.getters['campaigns/getCampaigns']('one_off').length;
    }
  },
  inject: ['setHeaderActions'],
  mounted() {
    this.$store.dispatch('campaigns/get');
    this.updateHeaderActions();
  },
  beforeUnmount() {
    if (this.setHeaderActions) {
      this.setHeaderActions(null);
    }
  },
  methods: {
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
    onContactsChange(contacts) {
      this.selectedContacts = contacts;
    },
    onCreateCampaign() {
      this.openAddPopup();
    },
    openCreateGroupModal() {
      this.showCreateGroupModal = true;
    },
    closeCreateGroupModal() {
      this.showCreateGroupModal = false;
    },
    onGroupCreated() {
      this.closeCreateGroupModal();
      if (this.$refs.groupsManager) {
        this.$refs.groupsManager.fetchGroups();
      }
      this.onGroupsUpdated();
    },
    onGroupsUpdated() {
      this.groupsVersion += 1;
    },
    onGroupsCountChanged(count) {
      this.groupsCount = count;
    },
    onClearContacts() {
      this.selectedContacts = [];
    },
    onRemoveContact(contactId) {
      this.selectedContacts = this.selectedContacts.filter(
        contact => contact.id !== contactId
      );
    },
    onTabChange(tabIndex) {
      this.activeTab = tabIndex;
    },
    openAddToGroupModal() {
      this.showAddToGroupModal = true;
    },
    closeAddToGroupModal() {
      this.showAddToGroupModal = false;
    },
    onContactsAddedToGroup() {
      this.closeAddToGroupModal();
      this.onGroupsUpdated();
    },
    openImportCsvModal() {
      this.showImportCsvModal = true;
    },
    closeImportCsvModal() {
      this.showImportCsvModal = false;
    },
    onGroupImportedFromCsv() {
      this.closeImportCsvModal();
      if (this.$refs.groupsManager) {
        this.$refs.groupsManager.fetchGroups();
      }
      this.onGroupsUpdated();
    },
    updateHeaderActions() {
      if (!this.setHeaderActions) return;
      
      const self = this;
      const ButtonComponent = {
        name: 'CampaignHeaderButtons',
        render() {
          return h('div', { class: 'flex flex-wrap items-center justify-end gap-1' }, [
            self.hasSelectedContacts && self.activeTab === 0
              ? h(WootButton, {
                  type: 'button',
                  variant: 'hollow',
                  colorScheme: 'secondary',
                  size: 'small',
                  icon: 'add-circle',
                  title: self.$t('CAMPAIGN.ADD.CONTACTS.CREATE_BUTTON'),
                  onClick: self.onCreateCampaign,
                })
              : null,
            self.canCreateGroup && self.activeTab === 0
              ? h(WootButton, {
                  type: 'button',
                  variant: 'hollow',
                  colorScheme: 'secondary',
                  size: 'small',
                  icon: 'people-team-add',
                  title: self.$t('CAMPAIGN.ADD.CONTACTS.GROUP.CREATE_BUTTON'),
                  onClick: self.openCreateGroupModal,
                })
              : null,
            self.hasSelectedContacts && self.activeTab === 0
              ? h(WootButton, {
                  type: 'button',
                  variant: 'hollow',
                  colorScheme: 'secondary',
                  size: 'small',
                  icon: 'person-assign',
                  title: self.$t('CAMPAIGN.ADD.CONTACTS.ADD_TO_GROUP_BUTTON'),
                  onClick: self.openAddToGroupModal,
                })
              : null,
            self.activeTab === 1
              ? h(WootButton, {
                  type: 'button',
                  variant: 'hollow',
                  colorScheme: 'secondary',
                  size: 'small',
                  icon: 'upload',
                  title: self.$t('CAMPAIGN.ADD.CONTACTS.GROUP.IMPORT_CSV_BUTTON'),
                  onClick: self.openImportCsvModal,
                })
              : null,
            self.activeTab === 2
              ? h(WootButton, {
                  type: 'button',
                  variant: 'hollow',
                  colorScheme: 'secondary',
                  size: 'small',
                  icon: 'add-circle',
                  title: self.buttonText,
                  onClick: self.openAddPopup,
                })
              : null,
          ].filter(Boolean));
        },
      };
      this.setHeaderActions(ButtonComponent);
    },
  },
  watch: {
    hasSelectedContacts() {
      this.updateHeaderActions();
    },
    activeTab() {
      this.updateHeaderActions();
    },
    canCreateGroup() {
      this.updateHeaderActions();
    },
  },
};
</script>

<template>
  <div class="flex-1 overflow-auto">
    <!-- Conteúdo -->
    <div class="p-3">
    <!-- Tabs -->
    <div class="mb-4">
      <woot-tabs :index="activeTab" :border="true" @change="onTabChange">
        <woot-tabs-item
          :index="0"
          :name="$t('CAMPAIGN.ADD.CONTACTS.TABS.AUDIENCE')"
          :count="audienceCount"
        />
        <woot-tabs-item
          :index="1"
          :name="$t('CAMPAIGN.ADD.CONTACTS.TABS.GROUPS')"
          :count="groupsCount"
        />
        <woot-tabs-item
          :index="2"
          :name="$t('CAMPAIGN.ADD.CONTACTS.TABS.CAMPAIGNS')"
          :count="campaignsCount"
        />
      </woot-tabs>
    </div>

    <!-- Tab: Contatos (Audiência) -->
    <div v-show="activeTab === 0" class="space-y-6">
      <div class="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4">
        <h3 class="text-lg font-semibold text-slate-800 dark:text-slate-200 mb-4">
          {{ $t('CAMPAIGN.ADD.CONTACTS.TITLE') }}
        </h3>
        <CampaignContactsSelector
          :value="selectedContacts"
          @input="onContactsChange"
        />
        <div v-if="hasSelectedContacts" class="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
          <p class="text-sm text-blue-700 dark:text-blue-300">
            {{ $t('CAMPAIGN.ADD.CONTACTS.SELECTED_COUNT', { count: selectedContacts.length }) }}
          </p>
        </div>
      </div>
    </div>

    <!-- Tab: Grupos -->
    <div v-show="activeTab === 1" class="space-y-6">
      <CampaignGroupsManager
        ref="groupsManager"
        :selected-contacts="selectedContacts"
        @groups-updated="onGroupsUpdated"
        @groups-count-changed="onGroupsCountChanged"
      />
    </div>

    <!-- Tab: Campanhas -->
    <div v-show="activeTab === 2">
      <Campaign />
    </div>
    </div>
    <woot-modal :show.sync="showAddPopup" :on-close="hideAddPopup">
      <AddCampaign 
        :selected-contacts="selectedContacts"
        :groups-version="groupsVersion"
        @onClose="hideAddPopup"
        @clear-contacts="onClearContacts"
        @remove-contact="onRemoveContact"
      />
    </woot-modal>
    <woot-modal :show.sync="showCreateGroupModal" :on-close="closeCreateGroupModal">
      <CreateContactGroupModal
        :selected-contacts="selectedContacts"
        @success="onGroupCreated"
        @close="closeCreateGroupModal"
      />
    </woot-modal>
    <woot-modal :show.sync="showAddToGroupModal" :on-close="closeAddToGroupModal">
      <AddContactsToGroupModal
        :selected-contacts="selectedContacts"
        @success="onContactsAddedToGroup"
        @close="closeAddToGroupModal"
      />
    </woot-modal>
    <woot-modal :show.sync="showImportCsvModal" :on-close="closeImportCsvModal">
      <ImportContactGroupCsvModal
        @success="onGroupImportedFromCsv"
        @close="closeImportCsvModal"
      />
    </woot-modal>
  </div>
</template>

<style scoped>
/* Estilos removidos - botões agora estão no header */
</style>
